<template>
  <a-tag :color="attributes.textColor">
    {{ attributes.text || attributes.displayText }}
    <slot v-if="stateId === undefined || stateId === ''"></slot>
  </a-tag>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'Tags',
  props: {
    stateId: {
      type: [String, Number],
      default: ''
    },
    state: {
      type: Object,
      default: () => ({})
    },
    color: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const colorMap = {
      ticket: {
        1: { color: 'processing' }, // CREADO
        2: { color: 'warning' }, // PENDIENTE
        3: { color: 'success' }, // EJECUTADO
        4: { color: 'error' }, // CANCELADO
        5: { color: 'success' }, // FINALIZADO
        6: { color: 'warning' }, // EN APELACION
        7: { color: 'warning' }, // EN CORREDORA
        8: { color: 'warning' } // EN ASEGURADORA
      },
      default: {
        1: { name: 'CREADO', color: 'processing' },
        2: { name: 'PENDIENTE', color: 'warning' },
        3: { name: 'EJECUTADO', color: 'success' },
        4: { name: 'CANCELADO', color: 'error' },
        5: { name: 'FINALIZADO', color: 'success' },
        6: { name: 'EN APELACIÓN', color: 'warning' },
        7: { name: 'EN CORREDORA', color: 'warning' },
        8: { name: 'EN ASEGURADORA', color: 'warning' },
        9: { name: 'EN RESOLICITUD', color: 'warning' },
        10: { name: 'APROBADO', color: 'success' },
        11: { name: 'RECHAZADO', color: 'error' },
        12: { name: 'CANCELAR', color: 'error' },
        13: { name: 'VALIDACIÓN CORREDORA', color: 'warning' },
        14: { name: 'NO CUADRA', color: 'error' },
        15: { name: 'CUADRA', color: 'success' },
        16: { name: 'ERROR', color: 'success' },
        17: { name: 'VALIDO', color: 'success' }
      }
    };

    const attributes = computed(() => {
      const stateIdNum = Number(props.stateId);
      const data = colorMap.default[stateIdNum] || {};

      const displayText = props.state?.tag?.toUpperCase() || '';
      const text = data?.name || '';
      const fallbackColor = props.color || 'default';
      const defaultColor = data?.color || fallbackColor;

      let textColor = defaultColor;
      const typeEntry = colorMap[props.type];
      if (typeEntry?.[stateIdNum]?.color) {
        textColor = typeEntry[stateIdNum].color;
      }

      // console.log('Se está utilizando el componente tags con los valores: ', {
      //   stateId: props.stateId,
      //   state: props.state,
      //   color: props.color,
      //   type: props.type
      // });

      return {
        text,
        textColor,
        displayText
      };
    });

    return {
      attributes
    };
  }
};
</script>
